const TokenVisual = () => {
  return (
    <img
      src={process.env.PUBLIC_URL + '/token01.png'}
      alt="token"
      className="w-200 h-200 object-cover justify-center items-center"
    />
  );
};

export default TokenVisual;
